import { CalendarIcon } from "lucide-react";

/** What the date pickers' triggers and panels wear, shared so the single and
 *  range pickers read as one control: the house hairline field (the reading
 *  in mono over an underline, the calendar glyph trailing), a bare panel the
 *  {@link Calendar} fills. */

export function CalendarGlyph() {
  return (
    <CalendarIcon aria-hidden className="size-4 shrink-0 text-fg-subtle" />
  );
}

export const PICKER_TRIGGER_CLS =
  "flex w-full items-center justify-between gap-2 border-b border-line bg-transparent px-1 py-1.5 font-mono text-sm outline-none transition-colors hover:border-fg-subtle focus:border-fg data-[empty=true]:text-fg-subtle";
export const PICKER_PANEL_CLS =
  "fixed z-50 overflow-hidden rounded-lg border border-line bg-bg shadow-md";
